import { useState } from 'react';
import { Navigation, Map as MapIcon } from 'lucide-react';
import { useUtmTaxonomyStore } from '@/store/utm-taxonomy-store';

interface UtmMapControlsProps {
  onLocationClick: () => void;
}

const BASEMAPS = {
  street: { name: 'Street', url: 'mapbox://styles/mapbox/streets-v12' },
  dark: { name: 'Dark', url: 'mapbox://styles/mapbox/dark-v11' },
  satellite: { name: 'Satellite', url: 'mapbox://styles/mapbox/satellite-streets-v12' },
} as const;

const UtmMapControls: React.FC<UtmMapControlsProps> = ({ onLocationClick }) => {
  const { basemapStyle, setBasemapStyle } = useUtmTaxonomyStore();
  const [showBasemaps, setShowBasemaps] = useState(false);

  const currentBasemap =
    Object.entries(BASEMAPS).find(([, value]) => value.url === basemapStyle)?.[0] || 'street';

  return (
    <div className="absolute right-2 top-3 z-20 space-y-2 sm:right-4 sm:top-4">
      <button
        type="button"
        onClick={onLocationClick}
        className="rounded-lg border border-border bg-card p-2.5 text-muted-foreground shadow-xl transition-colors hover:bg-accent hover:text-accent-foreground sm:p-2"
        title="Go to my location"
      >
        <Navigation size={18} />
      </button>

      <div className="relative">
        <button
          type="button"
          onClick={() => setShowBasemaps((prev) => !prev)}
          className="w-full rounded-lg border border-border bg-card p-2.5 text-muted-foreground shadow-xl transition-colors hover:bg-accent hover:text-accent-foreground sm:p-2"
          title="Change basemap"
        >
          <MapIcon size={18} />
        </button>

        {showBasemaps && (
          <div className="absolute right-0 mt-1 bg-card border border-border rounded-lg shadow-xl overflow-hidden min-w-[120px]">
            {Object.entries(BASEMAPS).map(([key, { name, url }]) => (
              <button
                type="button"
                key={key}
                onClick={() => {
                  setBasemapStyle(url);
                  setShowBasemaps(false);
                }}
                className={`w-full px-4 py-2 text-left text-sm hover:bg-accent transition-colors ${
                  currentBasemap === key ? 'bg-primary text-primary-foreground' : 'text-muted-foreground'
                }`}
              >
                {name}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default UtmMapControls;
